var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.756.285H8.383A7.895 7.895 0 0 0 .488 8.18v26.318a7.895 7.895 0 0 0 7.895 7.895h47.373a7.895 7.895 0 0 0 7.895-7.895V8.18A7.895 7.895 0 0 0 55.756.285z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.471 21.084v5.519h-1.763V12.975h4.675c1.184 0 2.195.392 3.021 1.176.845.785 1.267 1.743 1.267 2.874 0 1.158-.422 2.116-1.267 2.89-.817.777-1.828 1.16-3.021 1.16H30.47v.009h.001zm0-6.431v4.752h2.948c.698 0 1.286-.237 1.745-.702a2.29 2.29 0 0 0 .707-1.67c0-.63-.238-1.185-.707-1.65-.459-.484-1.037-.72-1.745-.72h-2.947l-.001-.01zm11.811 2.317c1.304 0 2.332.346 3.085 1.04.753.693 1.13 1.64 1.13 2.846v5.746h-1.68v-1.295h-.074c-.726 1.067-1.7 1.596-2.911 1.596-1.038 0-1.901-.3-2.6-.912-.697-.611-1.046-1.368-1.046-2.28 0-.967.367-1.733 1.102-2.3.735-.574 1.717-.856 2.939-.856 1.047 0 1.91.19 2.58.574v-.401c0-.611-.239-1.122-.725-1.55a2.498 2.498 0 0 0-1.709-.64c-.982 0-1.763.41-2.332 1.24l-1.552-.966c.854-1.231 2.121-1.842 3.793-1.842zm-2.278 6.768c0 .456.193.84.588 1.14.386.3.845.456 1.368.456.744 0 1.405-.273 1.984-.82.578-.548.872-1.186.872-1.925-.55-.43-1.313-.648-2.296-.648-.716 0-1.313.173-1.79.51-.487.357-.726.785-.726 1.287zm16.08-6.467-5.877 13.427h-1.819L50.574 26l-3.875-8.73h1.92l2.79 6.695h.038l2.718-6.695h1.919z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.458 19.97c0-.55-.049-1.1-.147-1.642h-7.39v3.01h4.256a3.62 3.62 0 0 1-1.58 2.426v1.953h2.534c1.48-1.36 2.327-3.37 2.327-5.746z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.598 23.764c-.705.473-1.613.75-2.676.75-2.053 0-3.794-1.375-4.417-3.226H8.89v2.014a7.874 7.874 0 0 0 7.031 4.303c2.125 0 3.91-.694 5.21-1.89l-2.533-1.951z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.259 19.793c0-.52.087-1.022.246-1.495v-2.014H8.89a7.73 7.73 0 0 0-.836 3.51c0 1.262.302 2.453.836 3.508l2.614-2.014a4.682 4.682 0 0 1-.245-1.495z",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.922 15.073c1.16 0 2.199.397 3.019 1.172l2.245-2.229c-1.364-1.261-3.142-2.036-5.264-2.036a7.875 7.875 0 0 0-7.03 4.304l2.613 2.014c.623-1.851 2.364-3.225 4.417-3.225z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.756 1.162H8.384A7.018 7.018 0 0 0 1.366 8.18v26.318a7.018 7.018 0 0 0 7.018 7.018h47.372a7.018 7.018 0 0 0 7.018-7.018V8.18a7.018 7.018 0 0 0-7.018-7.018z",
    stroke: "url(#c)",
    strokeWidth: 1.755
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.66636 25.8986 -39.17583 -4.0333 45.062 15.565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ECC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#EDB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E99999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E66F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E74141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81515"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v43H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -50,
    y: -50,
    width: 164,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_428_326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_428_326",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.614dfd2e8d8c295b6a2eb61b8f1c285c.svg";
export { ForwardRef as ReactComponent };